import styled from 'styled-components'

export const Formulary = styled.div`
  display: flex;
  flex-direction: column;

  .container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    width: 100% !important;

    gap: 20px;
  }

  .subtitle {
    display: flex;
    align-items: center;

    width: 100%;

    margin-bottom: 16px;

    color: #070707;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
  }
`
